// Anonymous top-of-funnel visitor tracking (homepage + pricing).
// A first-party session token persists in localStorage across the browser
// session (and survives login, so a later paid subscription can be attributed).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const KEY = "visitor_session_token";

export function getVisitorToken() {
  let t = localStorage.getItem(KEY);
  if (!t) {
    t = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, t);
  }
  return t;
}

function post(path, body) {
  return fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).catch(() => {});
}

// Only track when NOT logged in (server also double-checks via JWT header absence).
export function trackHomepage() {
  if (localStorage.getItem("token")) return;
  post("/public/track/homepage", { session_token: getVisitorToken() });
}

export function trackPricing() {
  if (localStorage.getItem("token")) return;
  post("/public/track/pricing", { session_token: getVisitorToken() });
}

// Called after a successful login to resolve (exclude) the session.
export function trackLogin() {
  const t = localStorage.getItem(KEY);
  if (t) post("/public/track/login", { session_token: t });
}
